module.exports = __webpack_public_path__ + "img/3-puntos-vertical.3ac9ef79.svg";